import { createPinia } from 'pinia'
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './style.css'
import './styles/theme.scss'
import './styles/home.css'

// 开发环境提示使用mock数据
if (import.meta.env.DEV) {
    console.log('🎮 开发模式：使用Mock数据')
}

const app = createApp(App)
const pinia = createPinia()

app.use(pinia)
app.use(router)

app.mount('#app')